import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';

import style from './style';
import { configure } from '../../../config';
import { getImage, loadBgImage } from '../../../lib/utils';

import { Row, Column } from '@cube/layout';
import { RenderOnVisible, Truncate, Icon } from '@cube/blocks';
import { trackingProvider, getTrackingAttributesForAsset, trackProps, DIMENSION } from '@cube/track';
import { assetLink } from '@cube/utils';

export const canRender = (slide) => {
	if (slide.assets) {
		slide.assets = slide.assets.filter(asset => (asset.images && asset.images.length > 0 && asset.title_long));
		return slide.assets.length > 0;
	}

	return false;
};

export const getLink = (slide) =>
	assetLink(dlv(slide, 'assets.0.link'));

@trackingProvider({
	[DIMENSION.componentpath]: 'SingleAsset'
})
@configure({
	defaultImageSize: 'dccV2Config.singleAsset.defaultImageSize'
})
export class Card extends Component {

	onCardClick = (e) => {
		if (this.props.onCardClick) this.props.onCardClick({ pause: false });
	};

	getIcon(settings) {
		if (dlv(settings, 'assets.0.icon') === 'video') {
			return <Icon class={cx(style.icon, style.video)} name="play-cube" />;
		}
		if (dlv(settings, 'assets.0.metadata.attribution.citation') === 'Slideshow') {
			return <Icon class={cx(style.icon, style.slideshow)} name="gallery-cube" />;
		}

		return false;
	}

	getLinkoutParams(settings) {
		if (dlv(settings, 'assets.0.link.open_new_window')) {
			return {
				target: '_blank',
				rel: 'noopener noreferrer'
			};
		}
	}

	render({ settings, cardSize, overlayMode, lazy, onImageLoad, variant, ...props }) {
		if (!cardSize) cardSize = props.defaultImageSize;

		let styleProps = {};
		let backgroundImage = getImage(settings, cardSize);
		if (!lazy || this.loadedBG === backgroundImage) {
			// If actually loading for first time and onImageLoad defined, fire it
			if (onImageLoad && !this.loadedBG) {
				loadBgImage(backgroundImage, onImageLoad);
			}

			styleProps.style = `background-image: url('${backgroundImage}')`;
			this.loadedBG = backgroundImage;
		}
		let icon = this.getIcon(settings);

		return (
			<div data-tb-region-item class={style.wrapperDiv}>
				<a
					href={getLink(settings)}
					{...this.getLinkoutParams(settings)}
					{...styleProps}
					class={cx(style.cardSingleAsset, style[overlayMode], style[variant])}
					onClick={this.onCardClick}
					{...trackProps(getTrackingAttributesForAsset(settings), this.context)}
				>
					{ icon }
					<Row class={style.row}>
						<Column>
							<div class={style.title}>
								<RenderOnVisible>
									<Truncate method="multipleLines" lines="3">
										{dlv(settings, 'assets.0.title_long')}
									</Truncate>
								</RenderOnVisible>
							</div>
						</Column>
					</Row>
					<Row class={style.row}>
						<Column>
							<span class={style.attribution}>
								{dlv(settings, 'metadata.attribution.citation', dlv(settings, 'assets.0.metadata.attribution.citation'))}
							</span>
						</Column>
					</Row>
				</a>
			</div>
		);
	}
}

const SingleAsset = {
	canRender,
	getLink,
	Card
};

export default SingleAsset;
